if (!customElements.get("td-cart-drawer")) {
  class TdCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.htmlSelector = document.querySelector("html");
      this.cartTrigger = document.querySelector("[data-cart-drawer-toggle]");
      this.slider = this.querySelector(
        ".td-cart-drawer__recommended-slider-wrapper"
      );
      if (this.cartTrigger) {
        this.cartTrigger.addEventListener(
          "click",
          this.toggleDrawer.bind(this)
        );
      }
    }

    connectedCallback() {
      this.setInnerListeners();
      this.addEventListener("change", this.onChange.bind(this));
      this.addEventListener("addToCart", function () {
        this.reRenderCart();
      });
      document
        .querySelector(".td-overlay")
        .addEventListener("click", this.close.bind(this));
    }

    setInnerListeners() {
      this.querySelector(".td-close-cart").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.querySelectorAll(".remove").forEach((remove) => {
        remove.addEventListener("click", (event) => {
          this.updateQuantity(event.target.dataset.index, "0");
          event.preventDefault();
        });
      });
      this.notesToggle();
      this.setDiscountForm();
      this.updateSwiperSlides();
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
      this.setInnerListeners();
      this.openDrawer();
    }

    reRenderCart(productId = false, value = false) {
      const payload = {};
      payload.sections = this.getSectionsToRender().map(
        (section) => section.section
      );
      if (productId && value) {
        payload.updates = {};
        payload.updates[productId] = value;
      }
      return fetch(`${routes.cart_update_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify(payload),
      })
        .then((response) => response.json())
        .then((response) => {
          this.renderContents(response);
        });
    }

    openDrawer() {
      document.body.classList.add("td-overlay--active");
      this.htmlSelector.classList.add("td-overflow-hidden");
      this.classList.add("active");
      this.focus();
    }

    toggleDrawer(event) {
      event.preventDefault();
      const path = window.location.pathname;
      if (path == "/cart") return;
      document.body.classList.add("td-overlay--active");
      this.htmlSelector.classList.add("td-overflow-hidden");
      this.classList.add("active");
      this.focus();
    }

    onChange(event) {
      if (event.target.classList.contains("qty")) {
        this.updateQuantity(
          event.target.dataset.index,
          event.target.value,
          event.target
        );
      }
    }

    close() {
      this.classList.remove("active");
      document.body.classList.remove("td-overlay--active");
      this.htmlSelector.classList.remove("td-overflow-hidden");
    }

    setDiscountForm() {
      const discountForm = this.querySelector(".td-cart-drawer__discount-form");
      if (!discountForm) return;
      const discountFormToggle = this.querySelector(
        "[data-action='reveal-discount']"
      );
      const discountFormAction = this.querySelector(
        "[data-action='apply-discount']"
      );
      if (!discountFormToggle || !discountFormAction) return;
      discountFormToggle.addEventListener("click", () => {
        discountFormToggle.classList.add("active");
      });
      discountFormAction.addEventListener("click", async () => {
        discountForm.classList.add("td-loading");
        await this.applyDiscount();
      });
    }

    async applyDiscount() {
      const discountFormInput = document.querySelector(
        "[data-action='discount-input']"
      )?.value;
      if (!discountFormInput) {
        this.discountFormErrorHandler();
        return;
      }

      const discountApplyUrl = "/discount/" + discountFormInput;

      try {
        await fetch(discountApplyUrl);
        const response = await fetch("/cart.js");
        const cart = await response.json();
        let discountApplied = false;
        cart.cart_level_discount_applications.forEach((discount) => {
          if (discount.title === discountFormInput) {
            this.reRenderCart(false, false);
            discountApplied = true;
            return;
          }
        });

        if (!discountApplied) {
          this.discountFormErrorHandler();
        }
      } catch (err) {
        console.error("Error:", err);
        this.discountFormErrorHandler();
      } finally {
        document
          .querySelector(".td-cart-drawer__discount-form")
          ?.classList.remove("td-loading");
      }
    }

    discountFormErrorHandler() {
      document
        .querySelector(".td-cart-drawer__discount-form")
        ?.classList.remove("td-loading");
      document.querySelector("[data-action='discount-input']").value = "";
      document.querySelector("[data-action='discount-input']").focus();
      const discountError = document.querySelector(
        ".td-cart-drawer__discount-form__error-message"
      );
      if (discountError) {
        discountError.classList.add("active");
        setTimeout(() => discountError?.classList.remove("active"), 4000);
      }
    }

    notesToggle() {
      const noteElm = this.querySelector("[data-cart-note]");
      if (!noteElm) return;

      const noteToggler = noteElm.querySelector(
        "#td-cart-drawer__note-toggler"
      );
      const noteField = noteElm.querySelector("#td-cart-drawer__note-field");
      noteToggler.addEventListener("change", (event) => {
        noteElm.classList.toggle("active");
        if (!noteToggler.checked) {
          noteField.value = "";
          this.saveNotes("");
        }
      });

      noteField.addEventListener("change", (event) => {
        if (!noteElm.classList.contains("saving-note")) {
          noteElm.classList.add("saving-note");
          setTimeout(() => {
            const newNote = noteField.value;
            this.saveNotes(newNote);
            noteElm.classList.remove("saving-note");
          }, 2000);
        }
      });
    }

    saveNotes(notes) {
      fetch(`${routes.cart_update_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: JSON.stringify({
          note: notes,
        }),
      });
    }

    getSectionsToRender() {
      return [
        {
          id: "Td-Cart-Drawer",
          section: "td-cart-drawer",
          selector: ".td-cart-drawer",
        },
        {
          id: "cart-icon-bubble",
          section: "cart-icon-bubble",
          selector: ".header-cart__icon"
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selector).innerHTML;
    }

    updateSwiperSlides() {
      const slider = document.querySelector(
        ".td-cart-drawer__recommended-slider-wrapper"
      );
      const slides = Array.from(
        document.querySelectorAll(".td-cart-drawer__recommended__slide")
      );
      if (slides.length === 0) {
        if (slider) slider.classList.add("td-hide");
      } else {
        if (slider) slider.classList.remove("td-hide");
      }
    }

    updateQuantity(line, quantity, selector) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.add("td-loading");
      if (this.querySelector(".td-cart-drawer__error"))
        this.querySelector(".td-cart-drawer__error").style.display = "none";

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetch(`${routes.cart_change_url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        ...{
          body,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.errors) {
            const errorElm = this.querySelector(".td-cart-drawer__error");
            if (errorElm) {
              errorElm.textContent = response.errors;
              errorElm.style.display = "block";
            }
            if (selector) {
              selector.value = selector.value - 1;
            }
          } else {
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document
                  .getElementById(section.id)
                  .querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                response.sections[section.section],
                section.selector
              );
            });
          }
        })
        .finally(() => {
          if (this.querySelector(`#CartDrawerItem-${line}`)) {
            this.querySelector(`#CartDrawerItem-${line}`).classList.remove(
              "td-loading"
            );
          }
          this.setInnerListeners();
        })
        .catch((err) => {
          console.log("err: ", err);
          if (err) {
            if (this.querySelector(`#CartDrawerItem-${line}`)) {
              this.querySelector(`#CartDrawerItem-${line}`).classList.remove(
                "td-loading"
              );
            }
          }
        });
    }
  }
  customElements.define("td-cart-drawer", TdCartDrawer);
}
